<template>
  <v-container fluid>
    <h3 class="display-2">{{ searches.length }} orphaned searches</h3>

    <v-alert
      :value="true"
      type="warning"
      v-if="searches.length ===0 && !loading"
    >
      No active orphaned searches found.
    </v-alert>
    <v-list three-line
            v-if="searches.length > 0">
      <template v-for="(item, index) in searches">
        <v-list-tile
          :key="item.accountSearchId"
          :to="{ name: 'ubermetrics_search_edit', params: { id: item.accountSearchId }}"
          avatar
          ripple
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ item.searchName }}</v-list-tile-title>
            <v-list-tile-sub-title>
              <v-chip color="blue-grey" text-color="white" class="hidden-sm-and-down">
                <v-avatar class="blue-grey darken-2">{{item.accountId}}</v-avatar>
                Account ID
              </v-chip>
              <v-chip color="blue-grey" text-color="white" class="hidden-sm-and-down">
                <v-avatar class="blue-grey darken-2">{{item.searchId}}</v-avatar>
                Search ID
              </v-chip>
            </v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
        <v-divider
          v-if="index + 1 < searches.length"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import Config from '../utils/Config';
  import AmplifyStore from '../store/store';

  export default {
    data() {
      return {
        selected: null,
        info: null,
        loading: true,
        searches: [],
        search: '',
        errored: false,
        searchTimeout: null,
      };
    },
    mounted() {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken;
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
      this.$emit('TriggerLoading', true);
      axios.get(`${Config.API_URL}/ubermetrics-searches/orphaned`).then(response => {
        this.searches = response.data;
        this.loading = false;
        this.$emit('TriggerLoading', false);
      }).catch(error => {
        this.loading = false;
        console.log(error);
        this.errored = true;
      });
    },
  };
</script>
